
import Vue from 'vue'
import { Prop, Component } from 'vue-property-decorator'

@Component
export default class AppBackButton extends Vue {
  @Prop({ type: String, default: 'Back' })
  private readonly text!: string

  get showBack() {
    return window.history ? window.history.length > 1 : true
  }
}
